import React, { useState, useEffect } from "react";
import { Row, Form, OverlayTrigger, Tooltip, Button, Image, Col } from "react-bootstrap";
import SearchSelect from "../common/SearchSelect";
import InputBox from "../common/InputBox";
import DragDropRender from '../common/DrapDropRender';
import { DOCUMENT_STATUS_OPTIONS, DOCUMENT_FIELDS_CONFIG } from "../../utils/constant";
import InfoIcon from "../../assets/icons/Info.svg";
import RemarkHistoryModal from "../common/RemarkHistoryModal";
import editIcon from "../../assets/icons/EditIcon.svg";
import viewIcon from "../../assets/icons/view.svg";
import downloadIcon from "../../assets/icons/DownloadGray.svg";
import timelineIcon from "../../assets/icons/PreOrderTimeline.svg";
import discountIcon from "../../assets/icons/DiscountSanction.svg";
import refreshTimeIcon from "../../assets/icons/RefreshTime.svg"
import feedbackIcon from "../../assets/icons/Feedback.svg"
import { getFileNames, downloadFile, deleteFile } from "../../services/timeline-service";
import axios from "axios";

export default function OrderBookingTab({
    action, formValues, handleInputChange, errors, setErrors,
    mandatoryFields, setMandatoryFields, getDropDownOptions,
    obj, file, handleChangeStatus, handleDeleteDocument,
    handleUploadedFileDownload, commonFileUploadProps, commonProps,
    onEditIsob, onDownloadIsob, isobRevisionCount,
    timelineRecord, discountRecord, onViewTimeline, onViewDiscount,
    reasonForSubmissionMapping, showAmendmentIcon, onOpenAmendment,
    isTechnicalReadOnly, onDeletedOldFilesChange, resetKey, onLoadingChange,onNewRemarkChange,newRemark,setNewRemark 
}) {
    console.log("isTechnicalReadOnly", isTechnicalReadOnly);
    console.log("actionInOB", action);
    
    console.log("formvalues in view mode ", formValues);
    const [showRemarkHistory, setShowRemarkHistory] = useState(false);
    const [commercialFileNames, setCommercialFileNames] = useState([]);
    const [technicalFileNames, setTechnicalFileNames] = useState([]);
    const [deletedOldFiles, setDeletedOldFiles] = useState({ commercial: [], technical: [] });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        onLoadingChange?.(loading);
    }, [loading]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    const [openSections, setOpenSections] = useState({ orderInfo: false, reason: false, commercial: false, technical: false, remarks: false });

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 767);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSection = (key) => {
        setOpenSections(prev => ({ ...prev, [key]: !prev[key] }));
    };



    const getDocumentStatusOptions = (fieldName) => {
        const excludeList = DOCUMENT_FIELDS_CONFIG[fieldName]?.exclude || [];
        return DOCUMENT_STATUS_OPTIONS
            .filter((opt) => !excludeList.includes(opt))
            .map((value) => (
                <option key={value} value={value}>{value}</option>
            ));
    };

    const getCommercialFiles = async (orderBookingId) => {
        try {
            const filenames = await getFileNames(Number(orderBookingId), 'orderBooking');
            setCommercialFileNames(filenames);
        } catch (error) {
            console.log('Error fetching commercial files:', error);
        }
    };

    const getTechnicalFiles = async (obKitAttachmentId) => {
        try {
            const filenames = await getFileNames(Number(obKitAttachmentId), 'obkit');
            setTechnicalFileNames(filenames);
        } catch (error) {
            console.log('Error fetching technical files:', error);
        }
    };

    const handleFileDownload = async (filename, itemId, linkType) => {
        try {
            setLoading(true);
            const response = await downloadFile(itemId, filename, linkType);
            if (response.data && response.data.downloadUrl) {
                const fileResponse = await axios.get(response.data.downloadUrl, { responseType: 'blob' });
                const url = window.URL.createObjectURL(fileResponse.data);
                const link = document.createElement('a');
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                // await deleteFile(response.data.fileKey, linkType);
            }
        } catch (error) {
            console.error('Error downloading file:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCommercialDelete = (index) => {
        const oldFileCount = commercialFileNames.length;
        if (index < oldFileCount) {
            const filename = commercialFileNames[index];
            const updated = {
                ...deletedOldFiles,
                commercial: [...deletedOldFiles.commercial, filename],
            };
            setDeletedOldFiles(updated);
            setCommercialFileNames((prev) => prev.filter((_, i) => i !== index));
            onDeletedOldFilesChange && onDeletedOldFilesChange(updated);
        } else {
            handleDeleteDocument(index - oldFileCount, "CommercialAttachments");
        }
    };

    const handleTechnicalDelete = (index) => {
        const oldFileCount = technicalFileNames.length;
        if (index < oldFileCount) {
            const filename = technicalFileNames[index];
            const updated = {
                ...deletedOldFiles,
                technical: [...deletedOldFiles.technical, filename],
            };
            setDeletedOldFiles(updated);
            setTechnicalFileNames((prev) => prev.filter((_, i) => i !== index));
            onDeletedOldFilesChange && onDeletedOldFilesChange(updated);
        } else {
            handleDeleteDocument(index - oldFileCount, "TechnicalAttachments");
        }
    };

    console.log("formvalues in order booking add page ", formValues);

    useEffect(() => {
        const fetchFiles = async () => {
            if (action === "View" || action === "Edit") {
                setLoading(true);
                try {
                    if (formValues.ID) {
                        await getCommercialFiles(formValues.ID);
                    }
                    if (formValues.obKitAttachmentId) {
                        await getTechnicalFiles(formValues.obKitAttachmentId);
                    }
                } finally {
                    setLoading(false);
                }
            }
            setDeletedOldFiles({ commercial: [], technical: [] });
        };
        fetchFiles();
    }, [action, formValues.ID, formValues.obKitAttachmentId, resetKey]);

    const renderMobileSection = (sectionKey, title, content) => {
        if (!isMobile) return content;
        return (
            <div className="ob-mobile-section" key={sectionKey}>
                <div className="ob-mobile-section-header" onClick={() => toggleSection(sectionKey)}>
                    <span className="ob-mobile-section-title">{title}</span>
                    <span className={`ob-mobile-section-arrow ${openSections[sectionKey] ? 'open' : ''}`}>&#9662;</span>
                </div>
                {openSections[sectionKey] && (
                    <div className="ob-mobile-section-body">
                        {content}
                    </div>
                )}
            </div>
        );
    };

    const orderInfoContent = (
        <>
            {!isMobile && <h6 className="section-subheading ob-section-heading">Order information</h6>}
            <div className="order-info-section-colored">
                <Row className="modal-row">
                    <InputBox
                        type="text"
                        name="Branch"
                        id="Branch"
                        label="Branch*"
                        value={formValues.Branch}
                        fieldName="Branch"
                        required
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        setError={setErrors}
                        error={errors.Branch}
                        readOnly
                    />
                    <SearchSelect
                        name="Sitelocation"
                        value={formValues.Sitelocation}
                        option={getDropDownOptions("Executing Branch List")}
                        label="Execution*"
                        id="Sitelocation"
                        fieldName="Execution"
                        onChange={handleInputChange}
                        placeholder=""
                        required
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        setError={setErrors}
                        error={errors.Sitelocation}
                        hint="Kindly select Execution"
                        readOnly={action === "View"}
                    />
                    <SearchSelect
                        name="Plant"
                        value={formValues.Plant}
                        option={getDropDownOptions("Plant")}
                        label="Plant*"
                        id="Plant"
                        fieldName="Plant"
                        onChange={handleInputChange}
                        placeholder=""
                        required
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        setError={setErrors}
                        error={errors.Plant}
                        hint="Kindly select Plant"
                        readOnly={action === "View"}
                    />
                </Row>
                <Row className="modal-row">
                    <div className="ob-channel-routing-row">
                        {/* <div className="ob-channel-row">
                            <span className="ob-radio-label">Channel type*</span>
                            {getDropDownOptions("Channel Type").map((opt) => (
                                <Form.Check
                                    inline
                                    type="radio"
                                    key={opt.props.value}
                                    label={opt.props.children}
                                    name="ChannelType"
                                    value={opt.props.value}
                                    checked={formValues.ChannelType === opt.props.value}
                                    onChange={handleInputChange}
                                    disabled={true}
                                />
                            ))}
                        </div> */}
                        <div className="ob-routing-row">
                            <span className="ob-radio-label-routing">Routing type*</span>
                            {getDropDownOptions("Routing").map((opt) => (
                                <Form.Check
                                    inline
                                    type="radio"
                                    key={opt.props.value}
                                    label={opt.props.children}
                                    name="Routing"
                                    value={opt.props.value}
                                    checked={formValues.Routing === opt.props.value}
                                    onChange={handleInputChange}
                                    disabled={action === "View"}
                                />
                            ))}
                        </div>
                    </div>
                </Row>
                <Row className="modal-row">
                    <SearchSelect
                        name="PG"
                        value={Array.isArray(formValues.PG) ? formValues.PG : (formValues.PG?.results || [])}
                        option={getDropDownOptions("PG")}
                        label="PG*"
                        id="PG"
                        fieldName="PG"
                        onChange={handleInputChange}
                        placeholder=""
                        required
                        isMulti
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        setError={setErrors}
                        error={errors.PG}
                        hint="Kindly select PG"
                        readOnly={action === "View"}
                    />
                    <SearchSelect
                        name="ScopeOfInstallation"
                        value={formValues.ScopeOfInstallation}
                        option={getDropDownOptions("ScopeOfInstallation")}
                        label="Installed By*"
                        id="ScopeOfInstallation"
                        fieldName="Installed By"
                        onChange={handleInputChange}
                        placeholder=""
                        required
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        setError={setErrors}
                        error={errors.ScopeOfInstallation}
                        hint="Kindly select Installed By"
                        readOnly={action === "View"}
                    />
                </Row>
                <Row className="modal-row">
                    <SearchSelect
                        name="OrderType"
                        value={formValues.OrderType}
                        option={getDropDownOptions("Enquiry type")}
                        label="Order Type*"
                        id="OrderType"
                        fieldName="Order Type"
                        onChange={handleInputChange}
                        placeholder=""
                        required
                        mandatoryFields={mandatoryFields}
                        setMandatoryFields={setMandatoryFields}
                        setError={setErrors}
                        error={errors.OrderType}
                        hint="Kindly select Order Type"
                        readOnly={action === "View"}
                    />
                    {(formValues.OrderType === "Service" || formValues.OrderType === "Service Swift") && (
                        <SearchSelect
                            name="Service_Category"
                            value={formValues.Service_Category && formValues.Service_Category.results ? formValues.Service_Category.results : (Array.isArray(formValues.Service_Category) ? formValues.Service_Category : [])}
                            option={getDropDownOptions("Service category")}
                            label="Category*"
                            id="Service_Category"
                            fieldName="Category"
                            onChange={handleInputChange}
                            placeholder=""
                            required
                            isMulti
                            mandatoryFields={mandatoryFields}
                            setMandatoryFields={setMandatoryFields}
                            setError={setErrors}
                            error={errors.Service_Category}
                            hint="Kindly select Category"
                            readOnly={action === "View"}
                        />
                    )}
                </Row>
            </div>
        </>
    );

    const reasonContent = (
        <div className={!isMobile ? "order-info-section-plain-noleftpad" : ""}>
            <Row className="modal-row add-edit-form">
                <div className="ob-reason-amendment-row">
                    <div className="ob-reason-row">
                        <SearchSelect
                            name="OrderBookingType"
                            value={formValues.OrderBookingType}
                            option={getDropDownOptions("ISOB Submission Type")}
                            label="Reason for submission*"
                            id="OrderBookingType"
                            fieldName="Reason for submission"
                            onChange={handleInputChange}
                            placeholder=""
                            required
                            mandatoryFields={mandatoryFields}
                            setMandatoryFields={setMandatoryFields}
                            setError={setErrors}
                            error={errors.OrderBookingType}
                            hint="Kindly select Reason for submission"
                            readOnly={action === "View"}
                        />
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip className="custom-tooltip">
                                {(() => {
                                    const selected = formValues.OrderBookingType?.trim()?.toLowerCase();
                                    const matchedKey = selected && reasonForSubmissionMapping
                                        ? Object.keys(reasonForSubmissionMapping).find(key => key.trim().toLowerCase() === selected)
                                        : null;
                                    if (matchedKey) return reasonForSubmissionMapping[matchedKey];
                                    return Object.entries(reasonForSubmissionMapping || {}).map(([key, val]) => (
                                        <div key={key} style={{ textAlign: 'left', marginBottom: 4 }}><b>{key}</b> - {val}</div>
                                    ));
                                })()}
                            </Tooltip>
                        }>
                            <img src={InfoIcon} alt="info" className="ob-info-icon" />
                        </OverlayTrigger>
                    </div>
                    {showAmendmentIcon && (
                        <div className="ob-reason-amendment-btn-wrapper">
                            <Button
                                className="ob-amendment-btn"
                                onClick={onOpenAmendment}
                            >
                                <img src={feedbackIcon} alt="" className="ob-amendment-btn-icon" />
                                View Order Amendment
                            </Button>
                        </div>
                    )}
                </div>
            </Row>
        </div>
    );

    const commercialContent = (
        <>
            {!isMobile && (
                <h6 className="section-subheading ob-section-heading-flex">
                    Commercial Attachments
                    <OverlayTrigger placement="bottom" overlay={<Tooltip className="custom-tooltip">Allowed file size is upto 25MB.Allowed file types are .PDF,.JPG,.JPEG,.PNG,.Doc,.Docx</Tooltip>}>
                        <img src={InfoIcon} alt="info" className="ob-info-icon" />
                    </OverlayTrigger>
                </h6>
            )}
            {action === "View" ? (
                <Row className="add-edit-form drag_file low-margin">
                    <Row style={{ display: "grid", marginBottom: '1rem' }}>
                        <span className="attachment-title">Attached Commercial Files:</span>
                    </Row>
                    {Array.isArray(commercialFileNames) && commercialFileNames.length > 0 ? (
                        <Row>
                            <Col className="file-attachment">
                                {commercialFileNames.map((file, i) => (
                                    <div key={i} className='inline-buttons uploaded-wrapper'>
                                        <span>
                                            <Form.Text
                                                className="fileupload-name view-file-name"
                                                onClick={() => handleFileDownload(file, formValues.ID, 'orderBooking')}
                                                title={file}
                                            >
                                                {file}
                                            </Form.Text>
                                        </span>
                                    </div>
                                ))}
                            </Col>
                        </Row>
                    ) : (
                        <span className="no-files-message">No commercial files attached</span>
                    )}
                </Row>
            ) : (
                <Row className="add-edit-form drag_file low-margin">
                    <DragDropRender
                        val={action === "Edit" ? [...commercialFileNames, ...(obj.CommercialAttachments || [])] : obj.CommercialAttachments}
                        name={"CommercialAttachments"}
                        label={"File upload"}
                        fileSizes={action === "Edit" ? [...commercialFileNames.map(() => null), ...(file?.CommercialAttachments?.map(f => f.size) || [])] : file?.CommercialAttachments?.map(f => f.size)}
                        readOnlyCount={0}
                        handleChangeEvent={(params) => handleChangeStatus(params, "CommercialAttachments")}
                        handleDeleteDocEvent={(index) => action === "Edit" ? handleCommercialDelete(index) : handleDeleteDocument(index, "CommercialAttachments")}
                        handleDownloadDocEvent={handleUploadedFileDownload}
                        action="Edit"
                        isSetError={true}
                        tableLayout
                        dropzoneVariant="dragdrop"
                        {...commonFileUploadProps}
                        maxFiles={10}
                        {...commonProps}
                    />
                </Row>
            )}
            <Row className="checklist-main-table">
                <div className="checklist-header-row">
                    <span className="attachment-title">Attachments Checklist</span>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip className="custom-tooltip">Checklist info</Tooltip>}>
                        <img src={InfoIcon} alt="info" className="ob-info-icon" />
                    </OverlayTrigger>
                </div>
                <div className="checklist-grid-container">
                    <div className="checklist-isob-row">
                        <span className="checklist-item-label">ISOB Rev {isobRevisionCount ? `${isobRevisionCount}.0` : "0.0"}*</span>
                        <Form.Select
                            className={`checklist-status-select ${formValues.ISOB === "Attached" ? "status-attached" : formValues.ISOB === "Not Applicable" ? "status-na" : "status-pending"}`}
                            name="ISOB"
                            value={formValues.ISOB || "Pending"}
                            onChange={handleInputChange}
                            disabled={true}
                        >
                            <option value="Pending">Pending</option>
                            <option value="Attached">Attached</option>
                        </Form.Select>
                        <div className="isob-revision-icons">
                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="custom-tooltip">{action === "View" ? "View ISOB" : action === "Edit" ? "Edit ISOB" : "Add ISOB"}</Tooltip>}>
                                <img src={action === "View" ? viewIcon : editIcon} alt={action === "View" ? "View" : action === "Edit" ? "Edit" : "Add"} className="isob-revision-icon" onClick={onEditIsob} />
                            </OverlayTrigger>
                        </div>
                    </div>
                    <div className="checklist-grid">
                        {[
                            { label: "Drawing Approval Mail*", fieldName: "DrawingApprovalMail", value: formValues.DrawingApprovalMail || "Pending" },
                            { label: "Site Checklist", fieldName: "SiteChecklist", value: formValues.SiteChecklist || "Pending", icon: "info" },
                            { label: `Final Direct Booking BOM${formValues.Routing === "Direct" ? "*" : ""}`, fieldName: "FinalDirectBookingBOM", value: formValues.FinalDirectBookingBOM || "Pending" },
                            { label: "Site Measurements", fieldName: "SiteMeasurements", value: formValues.SiteMeasurements || "Pending" },
                            { label: "LOI/Cust Confirmation*", fieldName: "LOICustConfirmation", value: formValues.LOICustConfirmation || "Pending" },
                            { label: "Delivery GST Address Proof", fieldName: "DeliveryGSTAddressProof", value: formValues.DeliveryGSTAddressProof || "Pending" },
                            { label: "Customer PO", fieldName: "CustomerPO", value: formValues.CustomerPO || "Pending" },
                            { label: "TDS declaration", fieldName: "TDSDeclaration", value: formValues.TDSDeclaration || "Pending" },
                            { label: `Dealer PO${formValues.ChannelType === "Dealer" ? "*" : ""}`, fieldName: "DealerPO", value: formValues.DealerPO || "Pending" },
                            { label: "Phy. Material Confirmation", fieldName: "PhyMaterialConfirmation", value: formValues.PhyMaterialConfirmation || "Pending" },
                            { label: "Drawing/Layout", fieldName: "DrawingLayout", value: formValues.DrawingLayout || "Pending" },
                            { label: "Advance Receipt", fieldName: "AdvanceReceipt", value: formValues.AdvanceReceipt || "Pending" },
                            (() => {
                                const isSwift = formValues.OrderType?.trim().toLowerCase() === "swift";
                                const isNonSwiftOrService = formValues.OrderType && !isSwift;
                                const preOrderValue = isSwift
                                    ? "Not Applicable"
                                    : (timelineRecord?.EnquiryStatus === "Closed")
                                        ? "Attached"
                                        : (["Attached", "Pending"].includes(formValues.PreOrderTimeline) ? formValues.PreOrderTimeline : "Pending");
                                return { label: `Pre Order Timeline${isNonSwiftOrService ? "*" : ""}`, fieldName: "PreOrderTimeline", value: preOrderValue, autoAttached: !isSwift && !!(timelineRecord?.EnquiryStatus === "Closed"), alwaysDisabled: true, icon: "timeline" };
                            })(),
                            { label: "Additional Docs", fieldName: "AdditionalDocs", value: formValues.AdditionalDocs || "Pending" },
                            { label: "Discount Sanction*", fieldName: "DiscountSanction", value: (discountRecord && discountRecord.Approvalstatus?.trim() === "Approved") ? "Attached" : (formValues.DiscountSanction || "Pending"), autoAttached: !!(discountRecord && discountRecord.Approvalstatus?.trim() === "Approved"), alwaysDisabled: true, icon: "discount" },
                        ].map((item) => {
                            const cls = item.value === "Pending" ? "status-pending" : item.value === "Not Applicable" ? "status-na" : "status-attached";
                            return (
                                <div className="checklist-grid-item" key={item.fieldName}>
                                    <span className="checklist-item-label">
                                        {item.label}
                                        {item.icon === "timeline" && <img src={timelineIcon} alt="Timeline" title="View Pre Order Timeline" className="checklist-row-icon" onClick={onViewTimeline} />}
                                        {item.icon === "discount" && <img src={discountIcon} alt="Discount" title="View Discount Sanction" className="checklist-row-icon" onClick={onViewDiscount} />}
                                        {item.icon === "info" && (
                                            <OverlayTrigger placement="bottom" overlay={<Tooltip className="custom-tooltip">Site Checklist info</Tooltip>}>
                                                <img src={InfoIcon} alt="info" className="checklist-row-icon" />
                                            </OverlayTrigger>
                                        )}
                                    </span>
                                    <Form.Select
                                        className={`checklist-status-select ${cls}`}
                                        name={item.fieldName}
                                        value={item.value}
                                        onChange={handleInputChange}
                                        disabled={action === "View" || item.autoAttached || item.alwaysDisabled}
                                    >
                                        {getDocumentStatusOptions(item.fieldName)}
                                    </Form.Select>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </Row>
        </>
    );

    const technicalContent = (
        <>
            {!isMobile && (
                <h6 className="section-subheading ob-section-heading-flex">
                    Technical Attachments
                    <OverlayTrigger placement="bottom" overlay={<Tooltip className="custom-tooltip">Allowed file size is upto 25MB.Allowed file types are .PDF,.JPG,.JPEG,.PNG,.Doc,.Docx</Tooltip>}>
                        <img src={InfoIcon} alt="info" className="ob-info-icon" />
                    </OverlayTrigger>
                </h6>
            )}
            {action === "View" || isTechnicalReadOnly ? (
                <Row className="add-edit-form drag_file low-margin">
                    <Row style={{ display: "grid", marginBottom: '1rem' }}>
                        <span className="attachment-title">Attached Technical Files:</span>
                    </Row>
                    {Array.isArray(technicalFileNames) && technicalFileNames.length > 0 ? (
                        <Row>
                            <Col className="file-attachment">
                                {technicalFileNames.map((file, i) => (
                                    <div key={i} className='inline-buttons uploaded-wrapper'>
                                        <span>
                                            <Form.Text
                                                className="fileupload-name view-file-name"
                                                onClick={() => handleFileDownload(file, formValues.obKitAttachmentId, 'obkit')}
                                                title={file}
                                            >
                                                {file}
                                            </Form.Text>
                                        </span>
                                    </div>
                                ))}
                            </Col>
                        </Row>
                    ) : (
                        <span className="no-files-message">No technical files attached</span>
                    )}
                </Row>
            ) : (
                <Row className="add-edit-form drag_file low-margin">
                    <DragDropRender
                        val={action === "Edit" ? [...technicalFileNames, ...(obj.TechnicalAttachments || [])] : obj.TechnicalAttachments}
                        name={"TechnicalAttachments"}
                        label={"File upload"}
                        fileSizes={action === "Edit" ? [...technicalFileNames.map(() => null), ...(file?.TechnicalAttachments?.map(f => f.size) || [])] : file?.TechnicalAttachments?.map(f => f.size)}
                        readOnlyCount={0}
                        handleChangeEvent={(params) => handleChangeStatus(params, "TechnicalAttachments")}
                        handleDeleteDocEvent={(index) => action === "Edit" ? handleTechnicalDelete(index) : handleDeleteDocument(index, "TechnicalAttachments")}
                        handleDownloadDocEvent={handleUploadedFileDownload}
                        action="Edit"
                        isSetError={true}
                        tableLayout
                        dropzoneVariant="dragdrop"
                        {...commonFileUploadProps}
                        maxFiles={5}
                        {...commonProps}
                    />
                </Row>
            )}
        </>
    );

    const remarksContent = (
        <>
            {!isMobile && (
                <div className="remarks-header">
                    <h6 className="section-subheading ob-section-heading-flex">
                        Remarks
                        <OverlayTrigger placement="bottom" overlay={<Tooltip className="custom-tooltip">Show Remarks</Tooltip>}>
                            <img src={InfoIcon} alt="info" className="ob-info-icon" />
                        </OverlayTrigger>
                    </h6>
                    <Button
                        className="remarks-history-btn"
                        onClick={() => setShowRemarkHistory(true)}
                    >
                        <img src={refreshTimeIcon} alt="" className="remarks-history-icon" />
                        Show history
                    </Button>
                </div>
            )}
            <div className="remarks-block">
                <Form.Control
                    as="textarea"
                    name="newRemarks"
                    className="remarks-textarea"
                    value={action === "View"
                                ? (formValues.remarks || "").replace(/<br>/g, "\n").split("\n").map(line => line.replace(/^.+\):\s*/, "").trim()).filter(line => line !== "").join("\n")
                                : newRemark
                            }     
                    onChange={(e) => {
                    onNewRemarkChange?.(e.target.value);
                    }}   
                    maxLength={1000}
                    rows={4}
                    placeholder={action !== "View" ? "Enter your remark here..." : ""}
                    disabled={action === "View"}
                />
                {action !== "View" && (
                <div className="remarks-char-count">{newRemark.length} / 1000 chars</div>
            )}
                {/* <div className="remarks-char-count">{newRemark.length} / 1000 chars</div> */}
            </div>
            {isMobile && (
                <Button
                    className="remarks-history-btn"
                    onClick={() => setShowRemarkHistory(true)}
                >
                    <img src={refreshTimeIcon} alt="" className="remarks-history-icon" />
                    Show history
                </Button>
            )}
        </>
    );

    return (
        <>
            <div className="form-right-adjust">
                {renderMobileSection('orderInfo', 'Order Information', orderInfoContent)}
                {renderMobileSection('reason', 'Reason for Submission*', reasonContent)}
                {renderMobileSection('commercial', 'Commercial Attachments*', commercialContent)}
                {renderMobileSection('technical', 'Technical Attachments', technicalContent)}
                {renderMobileSection('remarks', 'Remarks', remarksContent)}

                <RemarkHistoryModal
                    show={showRemarkHistory}
                    onHide={() => setShowRemarkHistory(false)}
                    approvalComments={formValues.remarks || ""}
                    onNewRemarkChange={(val) => onNewRemarkChange?.(val)}
                />
            </div>
        </>
    );
}
